export function saveAs(file: string, name: string) {
  const downloadUrl = `data:application/pdf;base64,${file}`;
  const a = document.createElement("a")
  a.href = downloadUrl
  a.download = name
  a.click()
}